"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var outline_1 = require("@heroicons/react/24/outline");
var react_1 = __importStar(require("react"));
require("../../../index.css");
var react_2 = require("@headlessui/react");
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.typingTimeout = null;
        _this.state = {
            error: "",
            valuePlaceholder: "",
            valueImage: "",
            onFocus: false,
            filterOptions: [],
        };
        _this.setAsyncState = function (newState) {
            return new Promise(function (resolve) { return _this.setState(newState, resolve); });
        };
        _this.componentDidMount = function () {
            _this.handleGetSuggestions();
            _this.handleGetPlaceholder();
        };
        _this.componentDidUpdate = function (prevProps) { return __awaiter(_this, void 0, void 0, function () {
            var oldOptionProps, newOptionProps;
            return __generator(this, function (_a) {
                if (JSON.stringify(this.props.value) !== JSON.stringify(prevProps.value)) {
                    this.handleGetPlaceholder();
                }
                oldOptionProps = [];
                newOptionProps = [];
                this.props.options.map(function (eachOption) {
                    newOptionProps.push({
                        key: eachOption.key,
                        label: eachOption.label,
                    });
                    return null;
                });
                prevProps.options.map(function (eachOption) {
                    oldOptionProps.push({
                        key: eachOption.key,
                        label: eachOption.label,
                    });
                    return null;
                });
                if (JSON.stringify(oldOptionProps) !== JSON.stringify(newOptionProps)) {
                    this.handleGetSuggestions();
                    if (!this.state.onFocus) {
                        this.handleGetPlaceholder();
                    }
                }
                return [2 /*return*/];
            });
        }); };
        _this.handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var testCond, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        testCond = false;
                        error = "Please select an option";
                        if (!this.props.optional) {
                            if (Array.isArray(this.props.value)) {
                                testCond = this.props.value.length > 0 ? true : false;
                            }
                            else {
                                testCond = this.props.value ? true : false;
                            }
                        }
                        else {
                            testCond = true;
                        }
                        if (!!testCond) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setAsyncState({ error: error })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.setAsyncState({ error: "" })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, testCond];
                }
            });
        }); };
        _this.handleGetPlaceholder = function () { return __awaiter(_this, void 0, void 0, function () {
            var valuePlaceholder, valueImage, isArrayValue;
            var _this = this;
            return __generator(this, function (_a) {
                valuePlaceholder = "";
                valueImage = "";
                isArrayValue = Array.isArray(this.props.value);
                if (isArrayValue) {
                    valuePlaceholder = [];
                }
                this.props.options.map(function (eachOption) {
                    var _a, _b;
                    if (isArrayValue && Array.isArray(valuePlaceholder)) {
                        if (_this.props.value.includes(eachOption.key)) {
                            valuePlaceholder.push(eachOption.label);
                        }
                    }
                    else {
                        if (eachOption.key === _this.props.value) {
                            valuePlaceholder = eachOption.label;
                            if (_this.props.type === "button") {
                                valueImage = (_a = eachOption.image) !== null && _a !== void 0 ? _a : "";
                            }
                            else if (_this.props.type === "icon") {
                                valueImage = (_b = eachOption.icon) !== null && _b !== void 0 ? _b : "";
                            }
                        }
                    }
                    return null;
                });
                this.setState({
                    valuePlaceholder: valuePlaceholder,
                    valueImage: valueImage,
                });
                return [2 /*return*/];
            });
        }); };
        _this.handleGetSuggestions = function () { return __awaiter(_this, void 0, void 0, function () {
            var filterOptions;
            var _this = this;
            return __generator(this, function (_a) {
                filterOptions = [];
                if (this.props.options) {
                    this.props.options.map(function (eachOption) {
                        var label = eachOption.label.toLowerCase();
                        var valuePlaceholder;
                        if (Array.isArray(_this.state.valuePlaceholder)) {
                            if (_this.state.valuePlaceholder.length > 0)
                                valuePlaceholder = _this.state.valuePlaceholder[0];
                        }
                        else
                            valuePlaceholder = _this.state.valuePlaceholder;
                        if ((_this.props.exclude && _this.props.exclude.includes(eachOption.key)) ||
                            label.includes(valuePlaceholder ? valuePlaceholder.toLowerCase() : ""))
                            filterOptions.push(eachOption);
                        return null;
                    });
                }
                this.setState({
                    filterOptions: filterOptions,
                });
                return [2 /*return*/];
            });
        }); };
        _this.handleOnChange = function (e) {
            if (_this.props.disabled)
                return;
            _this.setState({
                valuePlaceholder: e.target.value,
            });
            if (_this.typingTimeout) {
                clearTimeout(_this.typingTimeout);
                _this.typingTimeout = null;
            }
            _this.typingTimeout = setTimeout(function () {
                _this.handleGetSuggestions();
                if (_this.props.onSearch) {
                    _this.props.onSearch(_this.state.valuePlaceholder);
                }
            }, 250);
        };
        _this.handleBlur = function () {
            if (_this.props.disabled)
                return;
            _this.setState({
                onFocus: false,
                valuePlaceholder: "",
                valueImage: "",
            }, function () {
                _this.handleGetPlaceholder();
            });
            setTimeout(function () {
                var _a, _b;
                if (((_a = _this.props.cellInput) === null || _a === void 0 ? void 0 : _a.active) && _this.props.cellInput.onBlur) {
                    (_b = _this.props.cellInput) === null || _b === void 0 ? void 0 : _b.onBlur();
                }
            }, 250);
        };
        _this.handleFocus = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.props.disabled)
                return;
            _this.setState({
                onFocus: true,
            }, function () {
                _this.setState({
                    valuePlaceholder: "",
                    valueImage: "",
                }, function () {
                    _this.handleGetSuggestions();
                    if (_this.props.onSearch) {
                        _this.props.onSearch("");
                    }
                });
            });
        };
        _this.handleOnSelectChange = function (key) {
            var _a, _b;
            if (_this.props.value && Array.isArray(_this.props.value)) {
                var selectedValue = (_a = _this.props.value) !== null && _a !== void 0 ? _a : [];
                var newSelectedList = (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.length) > 0 ? _this.props.value : [];
                if ((_b = _this.props.value) === null || _b === void 0 ? void 0 : _b.includes(key)) {
                    newSelectedList.splice(newSelectedList.indexOf(key), 1);
                    if (_this.props.onChange) {
                        _this.props.onChange(newSelectedList);
                    }
                }
                else {
                    newSelectedList === null || newSelectedList === void 0 ? void 0 : newSelectedList.push(key);
                    if (_this.props.onChange) {
                        _this.props.onChange(newSelectedList);
                    }
                }
            }
            else {
                if (_this.props.onChange) {
                    _this.props.onChange(key === _this.props.value ? "" : key);
                }
            }
            _this.handleBlur();
        };
        _this.renderOptionContainer = function () {
            var position = _this.props.staticDropdown ? "static" : "absolute";
            var optionDropdown = (react_1.default.createElement("ul", { className: "".concat(position, " z-10 w-full min-w-fit bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm") }, _this.renderOptions()));
            if (_this.props.staticDropdown) {
                return (react_1.default.createElement(react_2.Transition, { as: react_1.Fragment, show: _this.state.onFocus, enter: "transform transition duration-[400ms] ease-in-out", enterFrom: "opacity-0 -translate-y-2", leave: "transform origin-bottom duration-200 transition ease-in-out", leaveTo: "opacity-0 -translate-y-2" }, optionDropdown));
            }
            else if (_this.state.onFocus) {
                return optionDropdown;
            }
            else
                return null;
        };
        _this.renderOptions = function () {
            var optionView = [];
            _this.state.filterOptions.map(function (eachOption) {
                var isSelected = false;
                if (Array.isArray(_this.props.value)) {
                    isSelected = _this.props.value.includes(eachOption.key);
                }
                else {
                    isSelected = _this.props.value === eachOption.key;
                }
                optionView.push(react_1.default.createElement("li", { key: eachOption.key, className: "text-gray-900 cursor-default select-none relative px-5 py-3 hover:bg-primary-300 group", onMouseDown: _this.handleOnSelectChange.bind(_this, eachOption.key) },
                    react_1.default.createElement("div", { className: "flex items-center" },
                        eachOption.icon && _this.props.type === "icon" && (react_1.default.createElement(react_1.default.Fragment, null, eachOption.icon)),
                        eachOption.image && _this.props.type === "button" && (react_1.default.createElement("img", { src: eachOption.image, alt: "", className: "h-6 w-6 mr-3 rounded-full" })),
                        react_1.default.createElement("span", { className: "font-normal block group-hover:text-white" }, eachOption.label),
                        isSelected && (react_1.default.createElement("span", { className: "text-primary-600 absolute inset-y-0 right-0 flex items-center pr-4 group-hover:text-white" },
                            react_1.default.createElement(outline_1.CheckIcon, { className: "h-5 w-5" }))))));
                return null;
            });
            if (_this.props.additional) {
                optionView.push(react_1.default.createElement("li", { key: "additional", className: "text-gray-900 relative px-5 py-3" },
                    react_1.default.createElement("div", { className: "flex items-center" }, _this.props.additional)));
            }
            return optionView;
        };
        _this.renderButtonOptions = function () {
            if (_this.state.valueImage) {
                if ((0, react_1.isValidElement)(_this.state.valueImage)) {
                    return react_1.default.createElement(react_1.default.Fragment, null, _this.state.valueImage);
                }
                else {
                    return (react_1.default.createElement("img", { src: _this.state.valueImage, alt: "", className: "h-6 w-6 mr-3 rounded-full" }));
                }
            }
            return null;
        };
        return _this;
    }
    Select.prototype.render = function () {
        var _a, _b, _c;
        var defaultPadding = "px-5 py-3";
        if ((_a = this.props.cellInput) === null || _a === void 0 ? void 0 : _a.active) {
            defaultPadding = "p-2";
        }
        var defaultFontSize = "text-base";
        if ((_b = this.props.cellInput) === null || _b === void 0 ? void 0 : _b.active) {
            defaultFontSize = "text-sm";
        }
        var defaultBorder = "border border-gray-300";
        if (((_c = this.props.cellInput) === null || _c === void 0 ? void 0 : _c.active) && !this.state.error) {
            defaultBorder = "border-0 hover:border hover:border-gray-300";
        }
        var defaultClassName = "relative block w-full ".concat(defaultBorder, " rounded-md mt-1 ").concat(defaultPadding, " ").concat(defaultFontSize, " text-gray-900 placeholder-gray-300 focus:border focus:border-primary-500 focus:outline-none");
        if (this.state.error) {
            defaultClassName += " mb-0.5 border-red-300";
        }
        if (this.props.selectClassName) {
            defaultClassName += " ".concat(this.props.selectClassName);
        }
        return (react_1.default.createElement("div", { className: "w-full ".concat(this.props.containerClassName) },
            react_1.default.createElement("div", { className: "relative" },
                react_1.default.createElement("div", { className: "flex justify-between" },
                    react_1.default.createElement("label", { className: "block text-sm font-medium text-gray-700" },
                        this.props.label,
                        this.props.labelExtra)),
                react_1.default.createElement("div", null,
                    this.props.type === "button" || this.props.type === "icon" ? (react_1.default.createElement("button", { className: defaultClassName, onClick: this.handleFocus, onBlur: this.handleBlur },
                        react_1.default.createElement("span", { className: "flex items-center" }, this.state.valuePlaceholder ? (react_1.default.createElement(react_1.default.Fragment, null,
                            this.renderButtonOptions(),
                            react_1.default.createElement("span", { className: "block truncate" }, this.state.valuePlaceholder))) : (react_1.default.createElement("span", { className: "block truncate text-gray-300" }, this.props.placeholder
                            ? this.props.placeholder
                            : "Select An Option"))),
                        react_1.default.createElement("span", { className: "pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2" },
                            react_1.default.createElement(outline_1.ChevronUpDownIcon, { className: "h-5 w-5 text-gray-400", "aria-hidden": "true" })))) : (react_1.default.createElement("input", { id: this.props.id, className: defaultClassName, value: this.state.valuePlaceholder, disabled: this.props.disabled, autoFocus: this.props.autoFocus, placeholder: this.props.placeholder
                            ? this.props.placeholder
                            : "Select An Option", onFocus: this.handleFocus, onBlur: this.handleBlur, onChange: this.handleOnChange })),
                    this.renderOptionContainer()),
                react_1.default.createElement("span", { className: "text-red-500 text-sm" }, this.state.error))));
    };
    return Select;
}(react_1.Component));
exports.Select = Select;
//# sourceMappingURL=index.js.map